import { useEffect, useState } from 'react';
import { Box, Switch, Typography } from '@mui/material';
import useStyles from './index.styles';

import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import {
  agentSocket,
  isAgentAvailable,
  setAgentSocket,
  setChatConnectionId,
  setIsAgentAvailable,
  setShowLiveChat,
  showLiveChat,
} from 'store/reducer/customerReducer';

import { getAccessToken } from 'utils/auth';
import IncomingMessageModal from 'components/IncomingMessageModal';
import { useLocation } from 'react-router-dom';

const AgentStatus = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const location = useLocation();
  console.log(
    '🚀 ~ file: AgentStatus.tsx:22 ~ AgentStatus ~ location:',
    location
  );

  const socket = useAppSelector(agentSocket);
  const agentAvailable = useAppSelector(isAgentAvailable);
  const liveChat = useAppSelector(showLiveChat);

  const [openIncomingModal, setOpenIncomingModal] = useState(false);
  const [customerId, setCustomerId] = useState('');

  const token = getAccessToken();

  const onAvailableChange = (checked: boolean) => {
    let newSocket: WebSocket | null = null;

    if (checked) {
      dispatch(setIsAgentAvailable(true));
      if (!socket) {
        newSocket = new WebSocket(
          `wss://zcgrcm9a45.execute-api.ap-south-1.amazonaws.com/stage?token=${token}`
        );
      }
    } else {
      dispatch(setIsAgentAvailable(false));
      if (socket && !liveChat) {
        socket.close();
        dispatch(setChatConnectionId(''));
      }
    }
    dispatch(setAgentSocket(newSocket));
  };

  useEffect(() => {
    const regex = /\/customer-details\//;
    if (!regex.test(location.pathname)) dispatch(setShowLiveChat(false));
  }, [dispatch, location]);

  useEffect(() => {
    console.log('ready:', socket?.readyState, WebSocket.OPEN);

    if (socket) {
      socket.onopen = (data) => {
        console.log('Websocket connection established');
      };

      socket.onmessage = (message: any) => {
        if (message.data && !liveChat) {
          setOpenIncomingModal(true);
          setCustomerId(JSON.parse(message.data).customer_id);
          dispatch(setChatConnectionId(JSON.parse(message.data).connection_id));
        }
      };

      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      socket.onclose = () => {
        console.log('WebSocket connection closed.');
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, liveChat]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          color: '#fff',
          padding: '0 1.5rem',
        }}
      >
        <Typography>Agent Status</Typography>

        <Switch
          checked={agentAvailable}
          onChange={(e) => {
            onAvailableChange(e.target.checked);
          }}
          className={classes.switch}
          size='medium'
        />

        <Box
          sx={{
            backgroundColor: agentAvailable ? '#6AC5AB' : '#6F6F6F',
            padding: '5px 1rem',
            borderRadius: '5px',
          }}
        >
          <Typography>
            {agentAvailable ? 'Available' : 'Unavailable'}
          </Typography>
        </Box>
      </Box>

      <IncomingMessageModal
        customerId={customerId}
        open={openIncomingModal}
        onClose={() => setOpenIncomingModal(false)}
      />
    </>
  );
};

export default AgentStatus;
